export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";